import GlobalReduxStore from 'stores/globalReduxStore';
import {getFastInstrumentType} from 'stores/selectors/aboutSelectors';
import {selectSessionUserUsername} from 'stores/selectors/sessionSelectors';
import {
  getInstrumentProcessStatus,
  resetInstrumentRunningProcess,
  updateInstrumentRunningProcess,
} from 'api/instrumentManagementApi';
import {InstrumentProcessType} from 'constants/instrumentStatusEnum';
import {CurrentStateEnum, FastRobotErrorcode, InstrumentStatuses} from '../../constants/dataEnum';
// eslint-disable-next-line import/no-cycle
import {getInstrumentStatus} from './instrumentBusiness';
import {showIsBusyModal} from './commonModalBusiness';
import {setErrorCodeNumber} from './commonBusiness';

export function checkIsInstrumentIdle(isCheckMotors) {
  return async (dispatch) => {
    try {
      const response = await dispatch(getInstrumentStatus());

      if (response) {
        if (response.currentState === CurrentStateEnum.IDLE) {
          if (isCheckMotors) {
            const {instrumentStatuses} = response;

            if (instrumentStatuses.includes('busy')) return false;
          }

          return true;
        }
      }
    } catch (err) {
      console.log(err);
    }

    return false;
  };
}

/**
 * Double check GetStatus to FastInstrument to prevent get stale status on running instrument
 * @returns instrument status response
 */
export const getInstrumentStatusDoubleCheck =
  (maxRecheck = 2) =>
  async (dispatch) => {
    let response;
    try {
      response = await dispatch(getInstrumentStatus());

      if (response && response.currentState === CurrentStateEnum.RUNNING) {
        const {instrumentStatuses, remainingTime} = response;

        const isRunningAlmostCompleted =
          instrumentStatuses?.length &&
          instrumentStatuses.includes(InstrumentStatuses.BUSY) &&
          remainingTime > 0 &&
          remainingTime < 3;

        if (isRunningAlmostCompleted && maxRecheck > 0) {
          response = await new Promise((resolve) => {
            setTimeout(async () => {
              const reCheckRes = await dispatch(getInstrumentStatusDoubleCheck(maxRecheck - 1));
              console.debug('getInstrumentStatus double check response', reCheckRes);

              resolve(reCheckRes);
            }, 2000);
          });
        }
      }
    } catch (err) {
      console.log(err);
    }

    return response;
  };

export const isV2Instrument = () => getFastInstrumentType(GlobalReduxStore.getState()) === '2';

export const getFastInstrumentTypeAsInt = () => parseInt(getFastInstrumentType(GlobalReduxStore.getState()), 10);

export const checkAndHandleIsAllowedToStartProcess = (processEnum) => async (dispatch, getState) => {
  const username = selectSessionUserUsername(getState());
  const {status, username: usernameExecutor} = (await getInstrumentProcessStatus()) || {};

  const isSameProcessOngoing = status === processEnum;
  const isExecutor = username === usernameExecutor;

  if (status === InstrumentProcessType.IDLE || (isExecutor && isSameProcessOngoing)) return true;

  await dispatch(setErrorCodeNumber(FastRobotErrorcode.Busy));
  dispatch(showIsBusyModal(usernameExecutor));
  return false;
};

export const setInstrumentProcess = (processName) => async (_, getState) => {
  const username = selectSessionUserUsername(getState());

  await updateInstrumentRunningProcess(username, processName);
};

export const clearInstrumentProcess =
  (bypassUsernameChecking = false) =>
  async (dispatch, getState) => {
    const username = selectSessionUserUsername(getState());
    const {username: usernameExecutor} = (await getInstrumentProcessStatus()) || {};

    if (usernameExecutor !== username && !bypassUsernameChecking) return;

    await resetInstrumentRunningProcess();
  };
